const phoneTooltipContainer = document.querySelector('.phone-tooltip');
const phoneTooltipTrigger = document.querySelector('button.header__icon--phone');

if (phoneTooltipContainer && phoneTooltipTrigger) {
    if (window.matchMedia('(max-width: 767px)').matches) {
        phoneTooltipTrigger.addEventListener('click', phoneTooltipEvent);
    }

    window.addEventListener('resize', () => {
        if (window.matchMedia('(max-width: 767px)').matches) {
            phoneTooltipTrigger.addEventListener('click', phoneTooltipEvent);
        } else {
            phoneTooltipContainer.classList.remove('phone-tooltip--active');
            phoneTooltipTrigger.removeEventListener('click', phoneTooltipEvent);
        }
    });
}

function phoneTooltipEvent(event) {
    if (!phoneTooltipContainer.contains(event.target)) {
        phoneTooltipContainer.classList.toggle('phone-tooltip--active');
    }

    function closePhoneTooltip(event) {
        if (!phoneTooltipContainer.contains(event.target) && !phoneTooltipTrigger.contains(event.target)) {
            phoneTooltipContainer.classList.remove('phone-tooltip--active');
            document.removeEventListener('click', closePhoneTooltip);
        }
    }

    document.addEventListener('click', closePhoneTooltip);
}
